import {
  Avatar,
  Badge,
  Box,
  Checkbox,
  HStack,
  Icon,
  IconButton,
  Table,
  Image,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Switch,
  Tr,
} from "@chakra-ui/react";
import * as React from "react";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import { KYDPromoCode } from "@common/interfaces/KYDCart";

export const PromoCodesTable = ({
  promoCodes,
  onEdit,
  readOnly = false,
  loading,
  ...props
}: {
  promoCodes: KYDPromoCode[];
  onEdit: (promoCode: KYDPromoCode) => void;
  loading: any;
  readOnly?: boolean;
}) => (
  <Table {...props}>
    <Thead>
      <Tr>
        <Th>Code</Th>
        <Th>Discount</Th>
        <Th>Uses</Th>
        <Th>Ticket Types</Th>
        <Th>Status</Th>
        <Th></Th>
      </Tr>
    </Thead>
    <Tbody>
      {promoCodes.map((promoCode: KYDPromoCode) => (
        <Tr key={promoCode.id}>
          <Td>
            <Text fontWeight="medium">{promoCode.code}</Text>
          </Td>
          <Td>
            <Text fontWeight="medium">
              {promoCode.description?.split("-").pop()?.trim()}
            </Text>
          </Td>
          <Td>
            <Text fontWeight="medium">{promoCode.total_uses || 0}</Text>
          </Td>
          <Td>
            <Text>{promoCode.ticket_type_ids.length}</Text>
          </Td>
          <Td>
            <Badge
              colorScheme={promoCode.status === "active" ? "green" : "red"}
            >
              {promoCode.status}
            </Badge>
          </Td>
          <Td>
            <HStack spacing="1" justifyContent="flex-end">
              {readOnly ? null : (
                <IconButton
                  isDisabled={loading["blocking"]}
                  onClick={() => onEdit(promoCode)}
                  icon={<FiEdit2 fontSize="1.25rem" />}
                  variant="ghost"
                  aria-label="Edit member"
                />
              )}
            </HStack>
          </Td>
        </Tr>
      ))}
    </Tbody>
  </Table>
);
